import { MenuItem } from "./menu.model";

export const MENU: MenuItem[] = [
  {
    label: "HOME",
    isTitle: true,
  },
  {
    label: "Dashboard",
    icon: "home",
    link: "/dashboard",
  },

  // {
  //   label: "Email",
  //   icon: "mail",
  //   subItems: [
  //     {
  //       label: "Inbox",
  //       link: "/apps/email/inbox",
  //     },
  //     {
  //       label: "Read",
  //       link: "/apps/email/read",
  //     },
  //     {
  //       label: "Compose",
  //       link: "/apps/email/compose",
  //     },
  //   ],
  // },


  // {
  //   label: "Onboarding",
  //   icon: "package",
  //   link: "/merchant/onboarding",
  // },
  // {
  //   label: "Create Merchant",
  //   icon: "activity",
  //   link: "/merchant/create-merchant",
  // },
  {
    label: "Manage Roles",
    isTitle: true,
  },
    {
    label: "Roles",
    icon: "package",
    link: "roles/roles-list",
  },
  {
    label: "Authorities",
    icon: "package",
    link: "roles/auths",
  },
  {
    label: "Sub Authorities",
    icon: "package",
    link: "roles/subAuths",
  },

  {
    label: "Manage Merchants",
    isTitle: true,
  },
  {
     label: "All Merchants",
    icon: "users",
    link: "merchant/merchants-list",

  },

 

  // {
  //   label: "Role Management",
  //   icon: "activity",
  //   link: "/merchant/manage-role",
  // },
  // {
  //   label: "Create Merchant",
  //   icon: "activity",
  //   link: "/apps/chat",
  // },
  // {
  //   label: "Invoice Details",
  //   icon: "message-square",
  //   link: "/apps/chat",
  // },
  // {
  //   label: "Calendar",
  //   icon: "calendar",
  //   link: "/apps/calendar",
  //   badge: {
  //     variant: "primary",
  //     text: "Event",
  //   },
  // },
  {
    label: "Manage Customers",
    isTitle: true,
  },
 {
    label: "All Customers",
    icon: "users",
    link: "/user-management/users-list",
  },


  
  // {
  //   label: "User_List",
  //   icon: "package",
  //   link: "/user-management/user-list",
  // },
  // {




  // {
  //   label: "Role Management",
  //   icon: "activity",
  //   link: "/merchant/manage-role",
  // },


  // {
  //   label: "UI Kit",
  //   icon: "feather",
  //   subItems: [
  //     {
  //       label: "Accordion",
  //       link: "/ui-components/accordion",
  //     },
  //     {
  //       label: "Alerts",
  //       link: "/ui-components/alerts",
  //     },
  //     {
  //       label: "Badges",
  //       link: "/ui-components/badges",
  //     },
  //     {
  //       label: "Breadcrumbs",
  //       link: "/ui-components/breadcrumbs",
  //     },
  //     {
  //       label: "Buttons",
  //       link: "/ui-components/buttons",
  //     },
  //     {
  //       label: "Button group",
  //       link: "/ui-components/button-group",
  //     },
  //     {
  //       label: "Cards",
  //       link: "/ui-components/cards",
  //     },
  //     {
  //       label: "Carousel",
  //       link: "/ui-components/carousel",
  //     },
  //     {
  //       label: "Collapse",
  //       link: "/ui-components/collapse",
  //     },
  //     {
  //       label: "Datepicker",
  //       link: "/ui-components/datepicker",
  //     },
  //     {
  //       label: "Dropdowns",
  //       link: "/ui-components/dropdowns",
  //     },
  //     {
  //       label: "List group",
  //       link: "/ui-components/list-group",
  //     },
  //     {
  //       label: "Media object",
  //       link: "/ui-components/media-object",
  //     },
  //     {
  //       label: "Modal",
  //       link: "/ui-components/modal",
  //     },
  //     {
  //       label: "Navs",
  //       link: "/ui-components/navs",
  //     },
  //     {
  //       label: "Navbar",
  //       link: "/ui-components/navbar",
  //     },
  //     {
  //       label: "Pagination",
  //       link: "/ui-components/pagination",
  //     },
  //     {
  //       label: "Popovers",
  //       link: "/ui-components/popovers",
  //     },
  //     {
  //       label: "Progress",
  //       link: "/ui-components/progress",
  //     },
  //     {
  //       label: "Rating",
  //       link: "/ui-components/rating",
  //     },
  //     {
  //       label: "Scrollbar",
  //       link: "/ui-components/scrollbar",
  //     },
  //     {
  //       label: "Spinners",
  //       link: "/ui-components/spinners",
  //     },
  //     {
  //       label: "Timepicker",
  //       link: "/ui-components/timepicker",
  //     },
  //     {
  //       label: "Tooltips",
  //       link: "/ui-components/tooltips",
  //     },
  //     {
  //       label: "Typeadhed",
  //       link: "/ui-components/typeahead",
  //     },
  //   ],
  // },
  // {
  //   label: "Contract Management",
  //   icon: "anchor",
  //   subItems: [
  //     {
  //       label: "Application Management",
  //       link: "/advanced-ui/cropper",
  //     },
  //     {
  //       label: "Owl carousel",
  //       link: "/advanced-ui/owl-carousel",
  //     },
  //     {
  //       label: "SortableJs",
  //       link: "/advanced-ui/sortablejs",
  //     },
  //     {
  //       label: "Sweet alert",
  //       link: "/advanced-ui/sweet-alert",
  //     },
  //   ],
  // },
  // {
    // {
    // label: "Forms",
    // icon: "file-text",
    // subItems: [
    //   {
    //     label: "Basic elements",
    //     link: "/form-elements/basic-elements",
    //   },
    //   {
    //     label: "Advanced elements",
    //     subItems: [
    //       {
    //         label: "Form validation",
    //         link: "/advanced-form-elements/form-validation",
    //       },
    //       {
    //         label: "Input mask",
    //         link: "/advanced-form-elements/input-mask",
    //       },
    //       {
    //         label: "Ng-select",
    //         link: "/advanced-form-elements/ng-select",
    //       },
    //       {
    //         label: "Ngx-chips",
    //         link: "/advanced-form-elements/ngx-chips",
    //       },
    //       {
    //         label: "Ngx-color-picker",
    //         link: "/advanced-form-elements/ngx-color-picker",
    //       },
    //       {
    //         label: "Ngx-dropzone",
    //         link: "/advanced-form-elements/ngx-dropzone-wrapper",
    //       },
    //     ],
      // },

    {
      label: "Manage Reports",
      isTitle: true,
    },
        {
    label: "Reports",
    icon: "message-square",
        //     label: "Advanced elements",

    subItems: [
      // {
      //   label: "Order Management",
      //   isTitle: true,
      // },
      {
         label: "Orders Report",
        // icon: "message-square",
        link: "/order-management",
      },
      {
        label: "Payment report",
        link: "/reports/payment-report",
      },
      {
        label: "Settlement report",
        link: "/reports/settlement-report",
      },
      // {
      //   label: "Settlemet report",
      //   link: "/reports/settlement-report",
      // },
    //   {
    //     label: "Payment Report",
    //    // icon: "message-square",
    //    link: "/order-management/payment-order",
    //  }
    ],
  },




  {
    label: "Manage CMS",
    isTitle: true,
  },
  {
    label: "Manage CMS",
    icon: "file-text",
    link:"/form-elements/editors",
        //     label: "Advanced elements",

//     subItems: [
//   {
//     label: " Terms & Condition ",
//     link: "/form-elements/editors",
  
//   },
//   {
//     label: " About US ",
//     link: "/form-elements/editors/about-us/",
  
//   },
// ]
},


{
  label: "Manage Complaints",
  isTitle: true,
},
{
  label: "Complaints",
  icon: "file-text",
  link:"/complaints/complaints-list",
},

{
  label: "Configurations",
  isTitle: true,
},
{
  label: "Rules",
  icon: "file-text",
  link:"config/params",
},
{
  label: "Business categories",
  icon: "file-text",
  link:"config/categories",
},
// {
//   label: "Merchant annual sales",
//   icon: "file-text",
//   link:"config/annualSales",
// },

{
  label: "Manage Commission",
  isTitle: true,
},
{
  label: "Merchants",
  icon: "file-text",
  link:"/commission/commission-data",
},
{
  label: "Commissions",
  icon: "file-text",
  link:"/commission/commissions-list",
},

// {
//   label: "Reports Management",
//   isTitle: true,
// },
//  {
//    label: "Reports",
//    icon: "file-text",
//    // isTitle: true,

//     subItems: [
//       {
//         label: "Payment report",
//         link: "/reports/payment-report",
//       },
      // {
      //   label: "Settlemet report",
      //   link: "/reports/settlement-report",
      // },
//     ],
//   },
      // {
      //   label: "Wizard",
      //   link: "/form-elements/wizard",
      // },
    // ],
  // },
  // {
  //   label: "Charts & graphs",
  //   icon: "pie-chart",
  //   subItems: [
  //     {
  //       label: "ApexCharts",
  //       link: "/charts-graphs/apexcharts",
  //     },
  //     {
  //       label: "ChartJs",
  //       link: "/charts-graphs/chartjs",
  //     },
  //   ],
  // },
  // {
  //   label: "Tables",
  //   icon: "layout",
  //   subItems: [
  //     {
  //       label: "Basic tables",
  //       link: "/merchant/basic-table",
  //     },
  //     {
  //       label: "Data table",
  //       link: "/merchant/data-table",
  //     },
  //     {
  //       label: "Ngx-datatable",
  //       link: "/merchant/ngx-datatable",
  //     },
  //   ],
  // },
  // {
  //   label: "Icons",
  //   icon: "smile",
  //   subItems: [
  //     {
  //       label: "Feather icons",
  //       link: "/icons/feather-icons",
  //     },
  //     {
  //       label: "Mdi icons",
  //       link: "/icons/mdi-icons",
  //     },
  //   ],
  // },
  // {
  //   label: "Pages",
  //   isTitle: true,
  // },
  // {
  //   label: "Special pages",
  //   icon: "book",
  //   subItems: [
  //     {
  //       label: "Blank page",
  //       link: "/general/blank-page",
  //     },
  //     {
  //       label: "Faq",
  //       link: "/general/faq",
  //     },
  //     {
  //       label: "Invoice",
  //       link: "/general/invoice",
  //     },
  //     {
  //       label: "Profile",
  //       link: "/general/profile",
  //     },
  //     {
  //       label: "Pricing",
  //       link: "/general/pricing",
  //     },
  //     {
  //       label: "Timeline",
  //       link: "/general/timeline",
  //     },
  //   ],
  // },
  // {
  //   label: "Authentication",
  //   icon: "unlock",
  //   subItems: [
  //     {
  //       label: "Login",
  //       link: "/auth/login",
  //     },
  //     {
  //       label: "Register",
  //       link: "/auth/register",
  //     },
  //   ],
  // },
  // {
  //   label: "Error",
  //   icon: "cloud-off",
  //   subItems: [
  //     {
  //       label: "404",
  //       link: "/error/404",
  //     },
  //     {
  //       label: "500",
  //       link: "/error/500",
  //     },
  //   ],
  // },
];

